import {FaDonate, FaHandHoldingHeart, FaHandsHelping, FaHome, FaRocketchat, FaUserTie} from "react-icons/fa";
import { TiMessages } from "react-icons/ti";

import Home from "./pages/home";
import { Permissions } from "./utils/Permissions/Permissions";

import BannerPage from "./pages/banner/banner";
import BannerForm from "./components/banner/banner-form";
import BannerDetailsPage from "./components/banner/banner-details";

import CategoryCharityPage from "./pages/category-charity";
import CategoryCharityForm from "./components/category-charity/category-charity-form";
import { GrOrganization } from "react-icons/gr";

import CategoryCharityDetails from "./components/category-charity/category-charity-details";
import CharityPage from "./pages/charity";
import CharityForm from "./components/charity/charity-form";
import CharityDetails from "./components/charity/charity-details";
import CategoryCampaignPage from "./pages/category-campaign";
import CategoryCampaignForm from "./components/category-campaign/category-campaign-form";
import CategoryCampaignDetails from "./components/category-campaign/category-campaign-details";
import CityPage from "./pages/city";
import CityForm from "./components/city/city-form";
import CityDetailsPage from "./components/city/city-details";
import { IoSettingsOutline } from "react-icons/io5";
import TrademarkManagerPage from "./pages/trademark-manager";
import TrademarkManagerForm from "./components/trademark-manager/trademark-manager-form";
import TrademarkManagerDetailsPage from "./components/trademark-manager/trademark-manager-details";
import BadgeCharityPage from "./pages/badge_charity";
import BadgeCharityForm from "./components/badge_charity/badge-charity-form";
import BadgeCharityDetailsPage from "./components/badge_charity/badge-charity-details";
// import OrphanPage from "./pages/orphan";
// import OrphanForm from "./components/orphan/orphan-form";
// import OrphanDetailsPage from "./components/orphan/orphan-details";
import DonationServicePage from "./pages/donation-service";
import DonationServiceFormWrapper from "./components/donation-service/donation-service-form";
import DonationServiceDetailsPage from "./components/donation-service/donation-service-details";
import AchievementPage from "./pages/achievement";
import AchievementFormWrapper from "./components/achievement/achievement-form";
import AchievementDetailsPage from "./components/achievement/achievement-details";
import DonationPage from "./pages/donation";
import DonationDetailsPage from "./components/donation/donation-details";
import CommonQuestionsPage from "./pages/common-question";
import CommonQuestionsForm from "./components/common-question/common-question-form";
import CommonQuestionsDetailsPage from "./components/common-question/common-question-details";
import PolicyTermDetailsPage from "./components/policy-term/policy-term-details";
import PolicyTermForm from "./components/policy-term/policy-term-form";
import GeneralSettingDetailsPage from "./components/general-setting/general-setting-details";
import GeneralSettingForm from "./components/general-setting/general-settings-form";
import CampaignPage from "./pages/campaign";
import CampaignForm from "./components/campaign/campaign-form";
import CampaignDetails from "./components/campaign/campaign-details";
import BannerAchievementScreenPage from "./pages/banner-achievements-screen";
import BannerCharityScreenPage from "./pages/banner-charities-screen";
import BannerAchievementScreenForm from "./components/banner-achievements-screen/banner-form";
import BannerCharityScreenForm from "./components/banner-charities-screen/banner-form";
import BannerCharityScreenDetailsPage from "./components/banner-charities-screen/banner-details";
import BannerAchievementScreenDetailsPage from "./components/banner-achievements-screen/banner-details";
// import BannerOrphanScreenPage from "./pages/banner-orphans-screen";
// import BannerOrphanForm from "./components/banner-orphans-screen/banner-form";
// import BannerOrphanDetailsPage from "./components/banner-orphans-screen/banner-details";
import BannerCategoryPage from "./pages/banner-category";
import BannerCategoryForm from "./components/banner-category/banner-form";
import BannerCategoryDetailsPage from "./components/banner-category/banner-details";
import BannerCharityPage from "./pages/banner-charity";
import BannerCharityForm from "./components/banner-charity/banner-form";
import BannerCharityDetailsPage from "./components/banner-charity/banner-details";
import BannerCampaignPage from "./pages/banner-campaign";
import BannerCampaignForm from "./components/banner-campaign/banner-form";
import BannerCampaignDetailsPage from "./components/banner-campaign/banner-details";
import BannerCampaignScreenPage from "./pages/banner-campaigns-screen";
import BannerCampaignScreenForm from "./components/banner-campaigns-screen/banner-form";
import BannerCampaignScreenDetailsPage from "./components/banner-campaigns-screen/banner-details";
import GeneralNotificationPage from "./pages/general-notification";
import GeneralNotificationForm from "./components/general-notification/general-notification-form";
import GeneralNotificationDetailsPage from "./components/general-notification/general-notification-details";

import BeneficiaryGroupsPage from "./pages/beneficiary-groups";
import BeneficiaryGroupsForm from "./components/beneficiary-groups/beneficiary-groups-form/index";
import BeneficiaryGroupsDetails from "./components/beneficiary-groups/beneficiary-groups-details/index";
import ContactUsPage from "./pages/contactus";
import Chat from "./pages/chat/Chat";
import ContactUsDetailsPage from "./components/contactus/contactus-details";
import {GiReceiveMoney} from "react-icons/gi";
import {DashboardOutlined} from "@ant-design/icons";
// import BeneficiaryGroupsForm from "./components/beneficiary-groups/beneficiary-groups-form";
// import BeneficiaryGroupsDetails from "./components/beneficiary-groups/beneficiary-groups-details";

export interface ICrudRoutes {
  path: string;
  component: React.ReactNode;
}

export interface ISubRoute {
  labelKey: string;
  icon?: JSX.Element;
  path: string;
  permissions: string[];
  component: any;
  crudRoutes?: ICrudRoutes[];
  exact?: boolean;
}

export interface IRoute {
  labelKey: string;
  icon: JSX.Element;
  path: string;
  crudRoutes?: ICrudRoutes[];

  hasSubMenus: boolean;
  subMenus?: ISubRoute[];

  permissions: string[];
  component: any;
  exact?: boolean;
}


export const routes: IRoute[] = [
  {
    labelKey: "home",
    icon: <DashboardOutlined />,
    path: "/",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_STATISTICS],
    component: <Home />,
  },
  {
    labelKey: "application_management",
    icon: <FaHome />,
    path: "/application-management",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_APPS_MANAGE],
    component: <Home />,
    subMenus: [
      {
        labelKey: "banners_general",
        path: "/banners-general",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerForm />,
          },
          {
            component: <BannerForm />,
            path: "create",
          },
          {
            component: <BannerDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_achievements",
        path: "/banners-achievements",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerAchievementScreenPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerAchievementScreenForm />,
          },
          {
            component: <BannerAchievementScreenForm />,
            path: "create",
          },
          {
            component: <BannerAchievementScreenDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      // {
      //   labelKey: "banners_orphans",
      //   path: "/banners-orphans",
      //   permissions: [Permissions.CAN_VIEW_BANNER],
      //   component: <BannerOrphanScreenPage />,
      //   crudRoutes: [
      //     {
      //       path: "update/:id",
      //       component: <BannerOrphanForm />,
      //     },
      //     {
      //       component: <BannerOrphanForm />,
      //       path: "create",
      //     },
      //     {
      //       component: <BannerOrphanDetailsPage />,
      //       path: "details/:id",
      //     },
      //   ],
      // },
      {
        labelKey: "banners_categories",
        path: "/banners-categories",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerCategoryPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerCategoryForm />,
          },
          {
            component: <BannerCategoryForm />,
            path: "create",
          },
          {
            component: <BannerCategoryDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_charities",
        path: "/banners-charities",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerCharityPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerCharityForm />,
          },
          {
            component: <BannerCharityForm />,
            path: "create",
          },
          {
            component: <BannerCharityDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_charities_screen",
        path: "/banners-charities-screen",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerCharityScreenPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerCharityScreenForm />,
          },
          {
            component: <BannerCharityScreenForm />,
            path: "create",
          },
          {
            component: <BannerCharityScreenDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_campaigns_screen",
        path: "/banners-campaigns-screen",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerCampaignScreenPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerCampaignScreenForm />,
          },
          {
            component: <BannerCampaignScreenForm />,
            path: "create",
          },
          {
            component: <BannerCampaignScreenDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_campaigns",
        path: "/banners-campaigns",
        permissions: [Permissions.CAN_VIEW_BANNER],
        component: <BannerCampaignPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerCampaignForm />,
          },
          {
            component: <BannerCampaignForm />,
            path: "create",
          },
          {
            component: <BannerCampaignDetailsPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },
  {
    labelKey: "setting",
    icon: <IoSettingsOutline />,
    path: "/",
    hasSubMenus: true,
    permissions: [],
    component: <Home />,
    subMenus: [
      {
        labelKey: "cities",
        path: "/cities",
        permissions: [Permissions.CAN_VIEW_CITY],
        component: <CityPage />,
        crudRoutes: [
          {
            path: "update/:id",

            component: <CityForm />,
          },
          {
            component: <CityForm />,
            path: "create",
          },
          {
            component: <CityDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "general_settings",
        path: "/general-settings",
        permissions: [Permissions.CAN_VIEW_GENERAL_SETTING],
        component: <GeneralSettingDetailsPage />,
        crudRoutes: [
          {
            path: "update",
            component: <GeneralSettingForm />,
          },
        ],
      },
      {
        labelKey: "generals_notification",
        path: "/general-notification",
        permissions: [Permissions.CAN_VIEW_GENERAL_NOTIFICATION],
        component: <GeneralNotificationPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <GeneralNotificationForm />,
          },
          {
            component: <GeneralNotificationForm />,
            path: "create",
          },
          {
            component: <GeneralNotificationDetailsPage />,
            path: "details/:id",
          },
        ],
      },

      {
        labelKey: "common_questions",
        path: "/common-questions",
        permissions: [Permissions.CAN_VIEW_COMMON_QUESTIONS],
        component: <CommonQuestionsPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CommonQuestionsForm />,
          },
          {
            component: <CommonQuestionsForm />,
            path: "create",
          },
          {
            component: <CommonQuestionsDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "policy_term",
        path: "/policy-term",
        permissions: [Permissions.CAN_VIEW_POLICY_TERM],
        component: <PolicyTermDetailsPage />,
        crudRoutes: [
          {
            path: "update",
            component: <PolicyTermForm />,
          },
        ],
      },
    ],
  },
  {
    labelKey: "charities_manager",
    icon: <GrOrganization />,
    path: "/charities",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_CATEGORIES_PRODUCTS],
    component: <Home />,
    subMenus: [
      {
        labelKey: "charities",
        path: "/charities",

        permissions: [Permissions.CAN_VIEW_CATEGORY],
        component: <CharityPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CharityForm />,
          },
          {
            component: <CharityForm />,
            path: "create",
          },
          {
            component: <CharityDetails />,
            path: "details/:id",
          }
        ],
      },
      {
        labelKey: "categories_charities",
        path: "/categories_charities",

        permissions: [Permissions.CAN_VIEW_CATEGORY],
        component: <CategoryCharityPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CategoryCharityForm />,
          },
          {
            component: <CategoryCharityForm />,
            path: "create",
          },
          {
            component: <CategoryCharityDetails />,
            path: "details/:id",
          }
        ],
      },
      {
        labelKey: "charity_managers",
        path: "/charity_managers",
        permissions: [Permissions.CAN_VIEW_CHARITY_MANAGER],
        component: <TrademarkManagerPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <TrademarkManagerForm />,
          },
          {
            component: <TrademarkManagerForm />,
            path: "create",
          },
          {
            component: <TrademarkManagerDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "badge_charities",
        path: "/badge-charities",
        permissions: [Permissions.CAN_VIEW_ALL_BADGE_CHARITIES],
        component: <BadgeCharityPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BadgeCharityForm />,
          },
          {
            component: <BadgeCharityForm />,
            path: "create",
          },
          {
            component: <BadgeCharityDetailsPage />,
            path: "details/:id",
          }
        ],
      },
    ],
  },
  {
    labelKey: "campaigns_manager",
    icon: <GiReceiveMoney />,
    path: "/campaigns",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_ALL_CAMPAIGN_CATEGORIES],
    component: <Home />,
    subMenus: [
      {
        labelKey: "campaigns",
        path: "/campaigns",

        permissions: [Permissions.CAN_VIEW_CATEGORY],
        component: <CampaignPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CampaignForm />,
          },
          {
            component: <CampaignForm />,
            path: "create",
          },
          {
            component: <CampaignDetails />,
            path: "details/:id",
          }
        ],
      },
      {
        labelKey: "categories_campaigns",
        path: "/categories_campaigns",

        permissions: [Permissions.CAN_VIEW_CAMPIGN_CATEGORY],
        component: <CategoryCampaignPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CategoryCampaignForm />,
          },
          {
            component: <CategoryCampaignForm />,
            path: "create",
          },
          {
            component: <CategoryCampaignDetails />,
            path: "details/:id",
          }
        ],
      },
    ],
  },
  // {
  //   labelKey: "orphans_manager",
  //   icon: <FaHandHoldingHeart />,
  //   path: "/orphans-manager",
  //   hasSubMenus: true,
  //   permissions: [Permissions.CAN_VIEW_ALL_CAMPAIGN_CATEGORIES],
  //   component: <Home />,
  //   subMenus: [
  //     {
  //       labelKey: "orphans",
  //       path: "/orphans",
  //
  //       permissions: [Permissions.CAN_VIEW_CATEGORY],
  //       component: <OrphanPage />,
  //       crudRoutes: [
  //         {
  //           path: "update/:id",
  //           component: <OrphanForm />,
  //         },
  //         {
  //           component: <OrphanForm />,
  //           path: "create",
  //         },
  //         {
  //           component: <OrphanDetailsPage />,
  //           path: "details/:id",
  //         }
  //       ],
  //     },
  //   ],
  // },
  {
    labelKey: "achievements_manager",
    icon: <FaHandsHelping />,
    path: "/achievements-manager",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_ALL_CAMPAIGN_CATEGORIES],
    component: <Home />,
    subMenus: [
      {
        labelKey: "achievements",
        path: "/achievements",

        permissions: [Permissions.CAN_VIEW_CATEGORY],
        component: <AchievementPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <AchievementFormWrapper />,
          },
          {
            component: <AchievementFormWrapper />,
            path: "create",
          },
          {
            component: <AchievementDetailsPage />,
            path: "details/:id",
          }
        ],
      },
    ],
  },
  {
    labelKey: "donations_manager",
    icon: <FaDonate />,
    path: "/donations-manager",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_ALL_CAMPAIGN_CATEGORIES],
    component: <Home />,
    subMenus: [
      {
        labelKey: "donations",
        path: "/donations",
        permissions: [Permissions.CAN_VIEW_CATEGORY],
        component: <DonationPage />,
        crudRoutes: [
          {
            component: <DonationDetailsPage />,
            path: "details/:id",
          }
        ],
      },
      {
        labelKey: "donation_service",
        path: "/donation-service",

        permissions: [Permissions.CAN_VIEW_CATEGORY],
        component: <DonationServicePage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <DonationServiceFormWrapper />,
          },
          {
            component: <DonationServiceFormWrapper />,
            path: "create",
          },
          {
            component: <DonationServiceDetailsPage />,
            path: "details/:id",
          }
        ],
      },
    ],
  },
  {
    labelKey: "beneficiary_groups_manager",
    icon: <FaHandHoldingHeart />,
    path: "/beneficiary-groups",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_ALL_BENEFICIARY_GROUPS],
    component: <Home />,
    subMenus: [
      {
        labelKey: "beneficiary-groups",
        path: "/beneficiary-groups",

        permissions: [Permissions.CAN_VIEW_BENEFICIARY_GROUP],
        component: <BeneficiaryGroupsPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BeneficiaryGroupsForm />,
          },
          {
            component: <BeneficiaryGroupsForm />,
            path: "create",
          },
          {
            component: <BeneficiaryGroupsDetails />,
            path: "details/:id",
          }
        ],
      },
    ],
  },
  {
    labelKey: "contactus_manager",
    icon: <TiMessages />,
    path: "/contact-messages",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_ALL_CONTACTUS],
    component: <ContactUsPage />,
    crudRoutes: [

      {
        component: <ContactUsDetailsPage />,
        path: "details/:id",
      }
    ],
  },
  {
    labelKey: "chat",
    icon: <FaRocketchat />,
    path: "/chat",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_CHAT],

    component: <Chat />,
  },
];
